import React, { useEffect, useState, useRef } from 'react'
import { ScrollView, Image, StyleSheet, Text, LayoutChangeEvent, TouchableOpacity, TouchableWithoutFeedback, View, useWindowDimensions, Platform, Dimensions, Modal } from 'react-native'

import { useNavigation, useIsFocused, useScrollToTop } from '@react-navigation/native'
import * as Clipboard from "expo-clipboard"
import { toast } from 'react-toastify'
import { Ionicons, MaterialCommunityIcons } from '@expo/vector-icons'
import { useQuery } from '@apollo/client'
import FsLightbox from 'fslightbox-react'
import ReactPlayer from 'react-player/youtube'
import dayjs from 'dayjs'

import ComfortsScreen from '../screens/Comforts';
import ReviewsScreen from '../screens/Reviews';
import 'dayjs/locale/ru'

import { FIND_UNIQUE_OBJECT_FOR_USER } from '../gqls'

import { imageUrl } from '../utils/const'
import { favoritesVar } from '../utils/cache'

import { useUser } from '../hooks/user'

import MapView from '../components/MapView'
import Loading from '../components/Loading'
import Error from '../components/Error'
import Window from '../components/Window'
import Helmet from "react-helmet"

const AutoVideo = ({ url, width, height, currentIndex, carouselIndex }) => {
    const [playing, setPlayling] = useState(false)

    useEffect(() => {
        if (carouselIndex !== currentIndex) {
            setPlayling(false)
        }
    }, [carouselIndex])

    return (
        <TouchableOpacity onPress={() => setPlayling(prev => !prev)} activeOpacity={1}>
            <ReactPlayer
                playing={playing}
                playsinline
                loop
                style={{ 'pointer-events': 'none' }}
                width={width}
                height={height}
                url={url}
            />
        </TouchableOpacity>
    )
}

const ObjectScreen = ({ route }) => {
    const { id, date } = route.params
    const { width } = useWindowDimensions()
    const navigation = useNavigation()
    const scrollRef = useRef()
    const isFocused = useIsFocused()
    const { user, refetch } = useUser()

    const [carouselIndex, setCarouselndex] = useState(0)
    const [toggler, setToggler] = useState(false)

    const squareSize = width > 1024 ? 480 : width - 32
    const dynamicWidth = width > 1024 ? 1024 : width - 32
    const dynamicWidthObjectImage = width > 1024 ? 1024 : width - 0

    const isMobile = width <= 1024;
    const isDesktop = width > 768;

    const [isExpanded, setIsExpanded] = useState(false);
    const ref = useRef(null);
    useScrollToTop(ref);

    const handleToggle = () => {
        setIsExpanded(!isExpanded);
    };

    const [modalComforts, setModalComforts] = useState(false);

    const [modalReviews, setModalReviews] = useState(false);

    const [isExpandedRules, setIsExpandedRules] = useState(false);

    const handleToggleRules = () => {
        setIsExpandedRules(!isExpandedRules);
    };

    useEffect(() => {
        if (isFocused) {
            refetch()
        }
    }, [isFocused])

    const { data: findUniqueObjectData, loading: findUniqueObjectLoading, error: findUniqueObjectError } = useQuery(FIND_UNIQUE_OBJECT_FOR_USER, {
        fetchPolicy: 'network-only',
        variables: {
            where: {
                id
            }
        }
    })

    if (findUniqueObjectLoading) return <Loading />
    if (findUniqueObjectError) return <Error />

    const { findUniqueObject } = findUniqueObjectData

    const images = findUniqueObject?.images_1024.length > 0 ? findUniqueObject?.images_1024.map(object => imageUrl(object)) || [] : findUniqueObject?.images?.map(object => imageUrl(object)) || []
    var imagesLightbox = (findUniqueObject?.images_1024?.length > 0
        ? findUniqueObject?.images_1024.map(object => imageUrl(object))
        : findUniqueObject?.images?.map(object => imageUrl(object))) || [];

    let videos

    if (findUniqueObject.videos.length > 0) {
        imagesLightbox = imagesLightbox.concat(findUniqueObject?.videos?.map(video => {
            if (video.includes('youtube.com/shorts/')) {
                return video.replace('/shorts/', '/embed/');
            }
            if (video.includes('vk.com/clip')) {
                const shortsVkUrlReplace = video.replace('_', '&id=');
                const videoVkUrl = shortsVkUrlReplace.replace('/clip-', '/video_ext.php?oid=-');
                return <iframe src={videoVkUrl} frameborder="0" width={436} height={777 + 68}></iframe>;
            }
            if (video.includes('vk.com/video')) {
                const videoUrlReplace = video.replace('_', '&id=');
                const videoUrl = videoUrlReplace.replace('/video-', '/video_ext.php?oid=-');
                return <iframe src={videoUrl} frameborder="0" width={windowWidth} height={windowHeight - 300}></iframe>;
            }
            if (video.includes('vkvideo.ru/clip')) {
                const shortsVkUrlReplace = video.replace('_', '&id=');
                const videoVkUrl = shortsVkUrlReplace.replace('/clip-', '/video_ext.php?oid=-');
                return <iframe src={videoVkUrl} frameborder="0" width={436} height={777 + 68}></iframe>;
            }
            if (video.includes('vkvideo.ru/video')) {
                const videoUrlReplace = video.replace('_', '&id=');
                const videoUrl = videoUrlReplace.replace('/video-', '/video_ext.php?oid=-');
                return <iframe src={videoUrl} frameborder="0" width={windowWidth} height={windowHeight - 300}></iframe>;
            }
            return video;
        }) || []);

        videos = {
            ...findUniqueObject,
            videos: findUniqueObject.videos?.map(videoVk => {
                if (videoVk.includes('vk.com/video')) {
                    const videoUrlReplace = videoVk.replace('_', '&id=');
                    const videoUrl = videoUrlReplace.replace('/video-', '/video_ext.php?oid=-');

                    return <iframe src={videoUrl} frameborder="0" width={windowWidth} height={windowHeight - 200}></iframe>;
                } else if (videoVk.includes('vkvideo.ru/video')) {
                    const videoUrlReplace = videoVk.replace('_', '&id=');
                    const videoUrl = videoUrlReplace.replace('/video-', '/video_ext.php?oid=-');

                    return <iframe src={videoUrl} frameborder="0" width={windowWidth} height={windowHeight - 200}></iframe>;
                } else if (videoVk.includes('vkvideo.ru/clip')) {
                    const videoUrlReplace = videoVk.replace('_', '&id=');
                    const videoUrl = videoUrlReplace.replace('/clip-', '/video_ext.php?oid=-');

                    return <iframe src={videoUrl} frameborder="0" width={windowWidth} height={windowHeight - 200}></iframe>;
                } else if (videoVk.includes('vk.com/clip')) {
                    const videoUrlReplace = videoVk.replace('_', '&id=');
                    const videoUrl = videoUrlReplace.replace('/clip-', '/video_ext.php?oid=-');

                    return <iframe src={videoUrl} frameborder="0" width={windowWidth} height={windowHeight - 200}></iframe>;
                }
                return videoVk; // Верните оригинальное видео, если условие не выполнено
            }) || []
        };


    }

    const addToFavorite = () => {
        favoritesVar([
            ...new Set([
                ...favoritesVar(),
                id
            ])
        ])
    }

    const onShare = async () => {
        await Clipboard.setStringAsync(window.location.href)
        toast(`Ссылка скопирована`)
        // try {
        //   const result = Share.share({
        //     title: 'Поделиться туром',
        //     message: '', 
        //     url: window.location.href
        //   });
        //   if (result.action === Share.sharedAction) {
        //     if (result.activityType) {
        //       // shared with activity type of result.activityType
        //     } else {
        //       // shared
        //     }
        //   } else if (result.action === Share.dismissedAction) {
        //     // dismissed
        //   }
        // } catch (error) {
        //     await Clipboard.setStringAsync(window.location.href)
        //     toast(`Ссылка скопировано.`)
        // }
    };

    const removeToFavorite = () => {
        const favorites = favoritesVar().filter(object => object !== id)
        favoritesVar([
            ...favorites
        ])
    }

    const handleOnScroll = (event) => {
        const currentIndex = parseInt(event.nativeEvent.contentOffset.x / dynamicWidth)
        setCarouselndex(currentIndex)
    }

    const getTags = (object) => {
        if (object.premium) {
            return (
                <View style={[styles.tagHot, { backgroundColor: '#BCC8B2' }]}>
                    <Text style={styles.hotText}>Интересно</Text>
                </View>
            )
        }
        if (object.hot) {
            return (
                <View style={styles.tagHot}>
                    <Text style={styles.hotText}>Горячие</Text>
                </View>
            )
        }
        return null
    }

    const getReviewTitle = (reviewCount) => {
        const cases = [2, 0, 1, 1, 1, 2];
        const titles = ['отзыв', 'отзыва', 'отзывов'];

        return `${reviewCount} ${titles[
            reviewCount % 100 > 4 && reviewCount % 100 < 20
                ? 2
                : cases[Math.min(reviewCount % 10, 5)]
        ]
            }`;
    }

    const getRating = (requests) => {
        if (requests.length === 0) return (0).toFixed(2)
        const rating = requests.map(object => object.rating).reduce((a = 0, b = 0) => a + b, 0) / requests.length
        if (rating === 0) return (0).toFixed(2)
        return rating.toFixed(2)
    }

    const getReviewCount = (requests) => {
        if (requests.length === 0) return 0
        return requests.filter(object => object.rating && object.rating !== 0).length
    }

    const getPeopleCount = (peopleInfo, people) => {
        if (peopleInfo) {
            return (
                <View style={styles.infoContainer}>
                    <View style={{ width: 24 }}>
                        <svg style={styles.infoContainerIcon} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M16.5 2.00007C15.7815 2.00227 15.077 2.19857 14.4609 2.56823C13.8448 2.93788 13.34 3.46715 13 4.10007C13.6592 4.23616 14.2839 4.50495 14.836 4.89006C15.0183 4.61588 15.2656 4.39096 15.5557 4.23528C15.8459 4.07959 16.17 3.99795 16.4992 3.9976C16.8285 3.99726 17.1528 4.07822 17.4433 4.2333C17.7337 4.38838 17.9814 4.61278 18.1644 4.88657C18.3473 5.16037 18.4598 5.4751 18.4918 5.80281C18.5239 6.13053 18.4746 6.46109 18.3482 6.76515C18.2218 7.06922 18.0223 7.33738 17.7674 7.54582C17.5125 7.75427 17.2101 7.89656 16.887 7.96005C17.0314 8.61838 17.0365 9.29962 16.902 9.96004C17.9247 9.86276 18.8704 9.37467 19.5422 8.59745C20.214 7.82022 20.56 6.81379 20.5082 5.78779C20.4564 4.76179 20.0107 3.79534 19.264 3.08975C18.5174 2.38415 17.5273 1.99383 16.5 2.00007Z" fill="black" />
                            <path d="M12 13C11.2089 13 10.4355 12.7654 9.77772 12.3259C9.11992 11.8864 8.60723 11.2617 8.30448 10.5308C8.00173 9.79988 7.92252 8.99561 8.07686 8.21969C8.2312 7.44377 8.61216 6.73104 9.17157 6.17163C9.73098 5.61222 10.4437 5.23126 11.2196 5.07692C11.9956 4.92258 12.7998 5.00179 13.5307 5.30454C14.2616 5.60729 14.8864 6.11998 15.3259 6.77778C15.7654 7.43557 16 8.20893 16 9.00005C16 10.0609 15.5786 11.0783 14.8284 11.8285C14.0783 12.5786 13.0609 13 12 13ZM12 7.00006C11.6044 7.00006 11.2178 7.11735 10.8889 7.33712C10.56 7.55688 10.3036 7.86923 10.1522 8.23468C10.0009 8.60014 9.96126 9.00227 10.0384 9.39023C10.1156 9.77819 10.3061 10.1346 10.5858 10.4143C10.8655 10.694 11.2219 10.8844 11.6098 10.9616C11.9978 11.0388 12.3999 10.9992 12.7654 10.8478C13.1308 10.6964 13.4432 10.4401 13.6629 10.1112C13.8827 9.78229 14 9.39561 14 9.00005C14 8.46962 13.7893 7.96091 13.4142 7.58584C13.0391 7.21077 12.5304 7.00006 12 7.00006Z" fill="black" />
                            <path d="M17 22H7C6.73478 22 6.48043 21.8946 6.29289 21.7071C6.10536 21.5196 6 21.2652 6 21V19C6.00159 17.6744 6.52888 16.4036 7.46622 15.4662C8.40356 14.5289 9.67441 14.0016 11 14H13C14.3256 14.0016 15.5964 14.5289 16.5338 15.4662C17.4711 16.4036 17.9984 17.6744 18 19V21C18 21.2652 17.8946 21.5196 17.7071 21.7071C17.5196 21.8946 17.2652 22 17 22ZM8 20H16V19C16 18.2044 15.6839 17.4413 15.1213 16.8787C14.5587 16.3161 13.7956 16 13 16H11C10.2044 16 9.44129 16.3161 8.87868 16.8787C8.31607 17.4413 8 18.2044 8 19V20Z" fill="black" />
                            <path d="M7 9.00005C7.00102 8.65076 7.03856 8.30253 7.112 7.96105C6.7889 7.89756 6.48647 7.75527 6.23157 7.54682C5.97667 7.33838 5.77718 7.07022 5.65081 6.76615C5.52444 6.46209 5.4751 6.13153 5.50716 5.80381C5.53923 5.4761 5.65172 5.16137 5.83464 4.88757C6.01756 4.61378 6.26525 4.38938 6.55573 4.2343C6.8462 4.07922 7.17047 3.99826 7.49975 3.9986C7.82903 3.99895 8.15314 4.08059 8.44328 4.23628C8.73343 4.39196 8.98066 4.61688 9.163 4.89106C9.71531 4.50547 10.3403 4.23634 11 4.10007C10.6737 3.4937 10.1959 2.98216 9.61315 2.61526C9.03043 2.24835 8.36263 2.03859 7.67478 2.00638C6.98692 1.97418 6.30245 2.12063 5.688 2.43148C5.07354 2.74234 4.55005 3.207 4.16849 3.78022C3.78692 4.35345 3.56028 5.01571 3.51065 5.70252C3.46101 6.38934 3.59005 7.07731 3.88522 7.69944C4.18039 8.32158 4.63163 8.85669 5.19499 9.25267C5.75836 9.64864 6.41466 9.892 7.1 9.95904C7.03569 9.64337 7.0022 9.3222 7 9.00005Z" fill="black" />
                            <path d="M17 11H16.571C16.162 11.9203 15.4875 12.6975 14.634 13.232C14.676 13.244 14.714 13.265 14.757 13.278C15.1462 13.0962 15.5704 13.0013 16 13H17C17.7956 13 18.5587 13.3161 19.1213 13.8787C19.6839 14.4413 20 15.2044 20 16V17H18.653C18.882 17.642 18.9993 18.3184 19 19H21C21.2652 19 21.5196 18.8947 21.7071 18.7071C21.8946 18.5196 22 18.2652 22 18V16C21.9984 14.6744 21.4711 13.4036 20.5338 12.4663C19.5964 11.5289 18.3256 11.0016 17 11Z" fill="black" />
                            <path d="M5.347 17H4V16C4 15.2044 4.31607 14.4413 4.87868 13.8787C5.44129 13.3161 6.20435 13 7 13H8C8.42993 13.0013 8.85442 13.0962 9.244 13.278C9.286 13.265 9.324 13.244 9.366 13.232C8.51249 12.6975 7.83802 11.9203 7.429 11H7C5.67441 11.0016 4.40356 11.5289 3.46622 12.4663C2.52888 13.4036 2.00159 14.6744 2 16V18C2 18.2652 2.10536 18.5196 2.29289 18.7071C2.48043 18.8947 2.73478 19 3 19H5C5.00065 18.3184 5.11801 17.642 5.347 17Z" fill="black" />
                        </svg>
                    </View>
                    <Text style={styles.infoText}>{peopleInfo}</Text>
                </View>
            )
        }
        if (people) {
            return (
                <View style={styles.infoContainer}>
                    <Ionicons name='ios-people-outline' size={24} color='#101828' />
                    <Text style={styles.infoText}>до {people} чел.</Text>
                </View>
            )
        }
        return null
    }

    const getBed = (bedInfo) => {
        if (!bedInfo) return null
        return (
            <View style={styles.infoContainer}>
                <View style={{ width: 24 }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M21 10.78V8C21 6.35 19.65 5 18 5H14C13.23 5 12.53 5.3 12 5.78C11.47 5.3 10.77 5 10 5H6C4.35 5 3 6.35 3 8V10.78C2.39 11.33 2 12.12 2 13V18C2 18.55 2.45 19 3 19C3.55 19 4 18.55 4 18V17H20V18C20 18.55 20.45 19 21 19C21.55 19 22 18.55 22 18V13C22 12.12 21.61 11.33 21 10.78ZM14 7H18C18.55 7 19 7.45 19 8V10H13V8C13 7.45 13.45 7 14 7ZM5 8C5 7.45 5.45 7 6 7H10C10.55 7 11 7.45 11 8V10H5V8ZM4 15V13C4 12.45 4.45 12 5 12H19C19.55 12 20 12.45 20 13V15H4Z" fill="black" />
                    </svg>
                </View>
                <Text style={styles.infoText}>{bedInfo}</Text>
            </View>
        )
    }

    const getSquare = (square) => {
        if (!square) return null
        return (
            <View style={styles.infoContainer}>
                <View style={{ width: 24 }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M21 8.59V4C21 3.45 20.55 3 20 3H15.41C14.52 3 14.07 4.08 14.7 4.71L16.29 6.3L6.29 16.3L4.7 14.71C4.08 14.08 3 14.52 3 15.41V20C3 20.55 3.45 21 4 21H8.59C9.48 21 9.93 19.92 9.3 19.29L7.71 17.7L17.71 7.7L19.3 9.29C19.92 9.92 21 9.48 21 8.59Z" fill="black" />
                    </svg>
                </View>
                <Text style={styles.infoText}>{square} м²</Text>
            </View>
        )
    }

    const getHeat = (heat) => {
        if (!heat) return null
        return (
            <View style={styles.infoContainer}>
                <View style={{ width: 24 }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M8.3662 3.88732L7.05634 5.87324L8.3662 7.85915L6.5493 10.6479L4.98592 9.84507L6.25352 7.85915L4.98592 5.87324L6.80282 3.08451L8.3662 3.88732ZM13.7746 3.80282L12.4648 5.78873L13.7746 7.77465L11.9577 10.5634L10.3944 9.76056L11.662 7.77465L10.3944 5.78873L12.2113 3L13.7746 3.80282ZM19.2254 3.80282L17.9155 5.78873L19.2254 7.77465L17.4085 10.5634L15.8451 9.76056L17.1127 7.77465L15.8451 5.78873L17.6197 3L19.2254 3.80282ZM3 21V13.8169C3 13.3099 3.17606 12.8803 3.52817 12.5282C3.88028 12.1761 4.29577 12 4.77465 12H19.2254C19.7042 12 20.1197 12.1761 20.4718 12.5282C20.8239 12.8803 21 13.3099 21 13.8169V21H19.2254V19.2254H4.77465V21H3ZM6.59155 13.8169C6.33803 13.8169 6.12676 13.9014 5.95775 14.0704C5.78873 14.2394 5.70423 14.4507 5.70423 14.7042V16.5211C5.70423 16.7746 5.78873 16.9859 5.95775 17.1549C6.12676 17.3239 6.33803 17.4085 6.59155 17.4085C6.84507 17.4085 7.05634 17.3239 7.22535 17.1549C7.39437 16.9859 7.47887 16.7746 7.47887 16.5211V14.7042C7.47887 14.4507 7.39437 14.2394 7.22535 14.0704C7.05634 13.9014 6.84507 13.8169 6.59155 13.8169ZM10.1831 13.8169C9.92958 13.8169 9.71831 13.9014 9.5493 14.0704C9.38028 14.2394 9.29577 14.4507 9.29577 14.7042V16.5211C9.29577 16.7746 9.38028 16.9859 9.5493 17.1549C9.71831 17.3239 9.92958 17.4085 10.1831 17.4085C10.4366 17.4085 10.6549 17.3239 10.838 17.1549C11.0211 16.9859 11.1127 16.7746 11.1127 16.5211V14.7042C11.1127 14.4507 11.0211 14.2394 10.838 14.0704C10.6549 13.9014 10.4366 13.8169 10.1831 13.8169ZM13.8169 13.8169C13.5634 13.8169 13.3451 13.9014 13.162 14.0704C12.9789 14.2394 12.8873 14.4507 12.8873 14.7042V16.5211C12.8873 16.7746 12.9789 16.9859 13.162 17.1549C13.3451 17.3239 13.5634 17.4085 13.8169 17.4085C14.0704 17.4085 14.2817 17.3239 14.4507 17.1549C14.6197 16.9859 14.7042 16.7746 14.7042 16.5211V14.7042C14.7042 14.4507 14.6197 14.2394 14.4507 14.0704C14.2817 13.9014 14.0704 13.8169 13.8169 13.8169ZM17.4085 13.8169C17.1549 13.8169 16.9437 13.9014 16.7746 14.0704C16.6056 14.2394 16.5211 14.4507 16.5211 14.7042V16.5211C16.5211 16.7746 16.6056 16.9859 16.7746 17.1549C16.9437 17.3239 17.1549 17.4085 17.4085 17.4085C17.662 17.4085 17.8732 17.3239 18.0423 17.1549C18.2113 16.9859 18.2958 16.7746 18.2958 16.5211V14.7042C18.2958 14.4507 18.2113 14.2394 18.0423 14.0704C17.8732 13.9014 17.662 13.8169 17.4085 13.8169Z" fill="#101828" />
                    </svg>
                </View>
                <Text style={[styles.infoText]}>{heat}</Text>
            </View>
        )
    }

    const getNote = (note) => {
        if (!note) return null
        return (
            <>
                <View style={styles.line} />
                <Text style={[styles.title, { marginTop: 8 }]}>Заметки от хозяина</Text>
                <View style={styles.infoContainer}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M7.26316 21C6.98398 21 6.71624 20.8884 6.51884 20.6899C6.32143 20.4913 6.21053 20.222 6.21053 19.9412V16.7647H4.10526C3.54691 16.7647 3.01143 16.5416 2.61662 16.1445C2.2218 15.7473 2 15.2087 2 14.6471V5.11765C2 4.55601 2.2218 4.01738 2.61662 3.62024C3.01143 3.22311 3.54691 3 4.10526 3H19.8947C20.4531 3 20.9886 3.22311 21.3834 3.62024C21.7782 4.01738 22 4.55601 22 5.11765V14.6471C22 15.2087 21.7782 15.7473 21.3834 16.1445C20.9886 16.5416 20.4531 16.7647 19.8947 16.7647H12.8958L7.92105 20.7681C7.7343 20.9183 7.50227 21.0001 7.26316 21ZM4.10526 5.11765V14.6471H7.26316C7.54233 14.6471 7.81007 14.7586 8.00748 14.9572C8.20489 15.1557 8.31579 15.4251 8.31579 15.7059V17.7378L11.8684 14.8789C12.0552 14.7287 12.2872 14.6469 12.5263 14.6471H19.8947V5.11765H4.10526Z" fill="#1F2A37" />
                        <path d="M7.78947 10.9412C8.37083 10.9412 8.84211 10.4671 8.84211 9.88235C8.84211 9.29758 8.37083 8.82353 7.78947 8.82353C7.20812 8.82353 6.73684 9.29758 6.73684 9.88235C6.73684 10.4671 7.20812 10.9412 7.78947 10.9412Z" fill="#1F2A37" />
                        <path d="M12 10.9412C12.5814 10.9412 13.0526 10.4671 13.0526 9.88235C13.0526 9.29758 12.5814 8.82353 12 8.82353C11.4186 8.82353 10.9474 9.29758 10.9474 9.88235C10.9474 10.4671 11.4186 10.9412 12 10.9412Z" fill="#1F2A37" />
                        <path d="M16.2105 10.9412C16.7919 10.9412 17.2632 10.4671 17.2632 9.88235C17.2632 9.29758 16.7919 8.82353 16.2105 8.82353C15.6292 8.82353 15.1579 9.29758 15.1579 9.88235C15.1579 10.4671 15.6292 10.9412 16.2105 10.9412Z" fill="#1F2A37" />
                    </svg>
                    <Text style={[styles.infoText, { marginTop: 0 }]}>
                        {note}
                    </Text>
                </View>
            </>
        )
    }

    const getLocation = (location) => {
        if (!location) return null
        const { pathname } = new URL(location)
        const coordinate = pathname?.split('/').reverse()[0]?.split('%2C')
        if (!coordinate) return null
        return (
            <>
                <View style={{ marginBottom: 24, marginTop: 8 }}>
                    <Text style={[styles.title, { marginTop: 0 }]}>Карта</Text>
                    {
                        findUniqueObject.address ? (
                            <Text style={{ fontSize: 16 }}>{findUniqueObject.address}</Text>
                        ) : null
                    }
                </View>
                <MapView location={{ longitude: coordinate[0], latitude: coordinate[1] }} />
            </>
        )
    }

    const onScrollNext = (length) => {
        scrollRef.current.index = scrollRef.current.index || 0
        if (length > (scrollRef.current.index + 1)) {
            scrollRef.current.index = scrollRef.current.index + 1
            scrollRef.current.scrollTo({
                x: scrollRef.current.index * dynamicWidth,
                animation: false
            })
        }
    }

    const onScrollPreview = () => {
        scrollRef.current.index = scrollRef.current.index || 0
        if (scrollRef.current.index !== 0) {
            scrollRef.current.index = scrollRef.current.index - 1
            scrollRef.current.scrollTo({
                x: scrollRef.current.index * dynamicWidth,
                animation: false
            })
        }
    }

    const openImage = () => {
        setToggler(prev => !prev)
    }

    return (
        <>
            <div>
                <Helmet
                    title={findUniqueObject.name}
                    meta={[
                        { "name": "description", "content": findUniqueObject.description },
                        { "name": "og:image", "content": 'https://domiki.ykt.ru/uploads/' + findUniqueObject.images[0] },
                        { "name": "twitter:image", "content": 'https://domiki.ykt.ru/uploads/' + findUniqueObject.images[0] },
                        { "name": "og:image:width", "content": 353 },
                        { "name": "og:image:height", "content": 512 },
                        { "name": "og:url", "content": 'https://domiki.ykt.ru/objects/' + findUniqueObject.id },
                        { "name": "og:title", "content": findUniqueObject.name + ' | domikiYkt' },
                        { "name": "og:type", "content": 'article' },
                    ]}
                    base={{ "href": "https://domiki.ykt.ru" }}
                />
            </div>
            <ScrollView ref={ref} showsVerticalScrollIndicator={false} style={styles.container} contentContainerStyle={{ marginBottom: 24 }}>
                <Window>
                    {isDesktop ? (
                        <View style={{ marginTop: windowWidth > 768 ? 50 : 0 }}>
                            <View style={styles.objectBtnWrap}>
                                <TouchableOpacity
                                    style={styles.back}
                                    onPress={() => {
                                        if (isMobile)
                                            window.history.back()
                                        else
                                            window.open("/objects", "_self")
                                    }}
                                >
                                    <Ionicons name='ios-chevron-back-outline' size={20} color='#111928' />
                                </TouchableOpacity>

                                <View style={{ gap: 12, flexDirection: 'row' }}>
                                    <TouchableOpacity onPress={onShare} style={styles.copyLink}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                            <path d="M14.3506 10.625L14.9756 9.99999C16.3563 8.61928 16.3563 6.38071 14.9756 5V5C13.5949 3.61929 11.3563 3.61929 9.97559 5L9.35059 5.625M10.6006 14.375L9.97559 15C8.59488 16.3807 6.3563 16.3807 4.97559 15V15C3.59488 13.6193 3.59488 11.3807 4.97559 9.99999L5.60059 9.37499" stroke="black" strokeWidth="1.47608" strokeLinecap="round" />
                                            <path d="M11.8506 8.125L8.10059 11.875" stroke="black" strokeWidth="1.47608" strokeLinecap="round" />
                                        </svg>
                                    </TouchableOpacity>
                                    {
                                        user ? (
                                            <>
                                                {
                                                    findUniqueObject.favorite ? (
                                                        <TouchableOpacity onPress={removeToFavorite} style={styles.favorite}>
                                                            <Ionicons name='ios-heart-sharp' size={20} color='#111928' />
                                                        </TouchableOpacity>
                                                    ) : (
                                                        <TouchableOpacity onPress={addToFavorite} style={styles.favorite}>
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                                <path d="M9.14045 4.91843L9.99994 5.79999L10.8596 4.91843C12.3575 3.38216 14.7734 3.36082 16.2968 4.85442L16.3607 4.91843C17.8587 6.45471 17.8795 8.93224 16.4231 10.4947L16.3607 10.5601L10 17.0833L3.63932 10.5601C2.12023 9.00222 2.12023 6.47634 3.63932 4.91843C5.15842 3.36052 7.62135 3.36052 9.14045 4.91843Z" stroke="#111928" strokeWidth="1.66667" strokeLinejoin="round" />
                                                            </svg>
                                                        </TouchableOpacity>
                                                    )
                                                }
                                            </>
                                        ) : null
                                    }
                                </View>
                            </View>
                            <View style={styles.desktopImageWrap}>
                                {
                                    images.slice(0, 1).map((object, index) => (
                                        <TouchableOpacity style={styles.firstObjectImage} key={index} onPress={openImage} activeOpacity={1}>
                                            <Image key={index} style={{ height: '100%', width: '100%' }} source={{ uri: object }} />
                                        </TouchableOpacity>
                                    ))
                                }
                                <View style={styles.otherObjectImage}>
                                    {
                                        images.slice(1, 5).map((object, index) => (
                                            <TouchableOpacity style={{ height: '50%', width: windowWidth <= 830 ? '48%' : '49%' }} key={index} onPress={openImage} activeOpacity={1}>
                                                <Image key={index} style={{ height: '100%', width: '100%' }} source={{ uri: object }} />
                                            </TouchableOpacity>
                                        ))
                                    }
                                </View>
                            </View>
                            <View style={styles.tagsContainer}>
                                {
                                    getTags(findUniqueObject)
                                }
                                <View style={styles.countContainer}>
                                    <Text style={styles.countText}>{5}/{findUniqueObject.images.length + findUniqueObject.videos.length}</Text>
                                </View>
                            </View>
                        </View>
                    ) : (
                        <View>
                            <ScrollView
                                ref={scrollRef}
                                style={[styles.objectImage, { height: squareSize }]}
                                scrollEventThrottle={160}
                                onScroll={handleOnScroll}
                                horizontal
                                pagingEnabled
                                showsHorizontalScrollIndicator={false}
                                decelerationRate={0}
                                snapToAlignment='center'
                            >
                                {
                                    images.map((object, index) => (
                                        <TouchableOpacity key={index} onPress={openImage} activeOpacity={1}>
                                            <Image key={index} style={{ height: squareSize, width: dynamicWidthObjectImage }} source={{ uri: object }} />
                                        </TouchableOpacity>
                                    ))
                                }
                                {
                                    videos && (
                                        videos.videos.map((object, index) => (
                                            React.isValidElement(object) && object.type === 'iframe' ? (
                                                object
                                            ) : (
                                                <AutoVideo
                                                    key={index}
                                                    url={object}
                                                    width={dynamicWidth}
                                                    height={squareSize}
                                                    currentIndex={index + findUniqueObject.images.length}
                                                    carouselIndex={carouselIndex}
                                                />
                                            )
                                        ))
                                    )
                                }
                            </ScrollView>
                            <View style={styles.head}>
                                <TouchableOpacity
                                    style={styles.back}
                                    onPress={() => {
                                        if (isMobile)
                                            window.history.back()
                                        else
                                            window.open("/objects", "_self")
                                    }}
                                >
                                    <Ionicons name='ios-chevron-back-outline' size={20} color='#111928' />
                                </TouchableOpacity>
                                <View style={{ flexDirection: 'row' }}>
                                    <TouchableOpacity onPress={onShare} style={styles.copyLink}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                            <path d="M14.3506 10.625L14.9756 9.99999C16.3563 8.61928 16.3563 6.38071 14.9756 5V5C13.5949 3.61929 11.3563 3.61929 9.97559 5L9.35059 5.625M10.6006 14.375L9.97559 15C8.59488 16.3807 6.3563 16.3807 4.97559 15V15C3.59488 13.6193 3.59488 11.3807 4.97559 9.99999L5.60059 9.37499" stroke="black" strokeWidth="1.47608" strokeLinecap="round" />
                                            <path d="M11.8506 8.125L8.10059 11.875" stroke="black" strokeWidth="1.47608" strokeLinecap="round" />
                                        </svg>
                                    </TouchableOpacity>
                                    {
                                        user ? (
                                            <>
                                                {
                                                    findUniqueObject.favorite ? (
                                                        <TouchableOpacity onPress={removeToFavorite} style={styles.favorite}>
                                                            <Ionicons name='ios-heart-sharp' size={20} color='#111928' />
                                                        </TouchableOpacity>
                                                    ) : (
                                                        <TouchableOpacity onPress={addToFavorite} style={styles.favorite}>
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                                <path d="M9.14045 4.91843L9.99994 5.79999L10.8596 4.91843C12.3575 3.38216 14.7734 3.36082 16.2968 4.85442L16.3607 4.91843C17.8587 6.45471 17.8795 8.93224 16.4231 10.4947L16.3607 10.5601L10 17.0833L3.63932 10.5601C2.12023 9.00222 2.12023 6.47634 3.63932 4.91843C5.15842 3.36052 7.62135 3.36052 9.14045 4.91843Z" stroke="#111928" strokeWidth="1.66667" strokeLinejoin="round" />
                                                            </svg>
                                                        </TouchableOpacity>
                                                    )
                                                }
                                            </>
                                        ) : null
                                    }
                                </View>
                            </View>
                            <View style={styles.objectImagesPaginationWrap}>
                                {
                                    imagesLightbox.map((image, index) => (
                                        <View style={[styles.objectImagesPagination, carouselIndex === index && styles.objectImagesPaginationActive]} key={index}></View>
                                    ))
                                }
                            </View>
                            <View style={styles.tagsContainer}>
                                {
                                    getTags(findUniqueObject)
                                }
                                <View style={styles.countContainer}>
                                    <Text style={styles.countText}>{carouselIndex + 1}/{findUniqueObject.images.length + findUniqueObject.videos.length}</Text>
                                </View>
                            </View>
                        </View>
                    )}
                    <View style={styles.objectInfoWrap}>
                        <Text style={styles.titleObject}>{findUniqueObject.name}</Text>
                        {getRating(findUniqueObject.requests.filter(object => object.rating > 0 && dayjs(object.ratingAt).diff(dayjs(), 'day') <= -3)) > 0 ?
                            <TouchableOpacity onPress={() => navigation.navigate('Reviews', { id: findUniqueObject.id })} style={styles.reviewContainer}>
                                <View style={styles.reviewGroup}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
                                        <path d="M8.00002 1.83337L10.2661 6.22244L15.3334 6.92626L11.6667 10.3427L12.5323 15.1667L8.00002 12.8891L3.46777 15.1667L4.33335 10.3427L0.666687 6.92626L5.7339 6.22244L8.00002 1.83337Z" fill="#E59F3C" stroke="#E59F3C" />
                                    </svg>
                                    <Text style={styles.rate}>{getRating(findUniqueObject.requests.filter(object => object.rating > 0 && dayjs(object.ratingAt).diff(dayjs(), 'day') <= -3))}</Text>
                                </View>
                                <Text style={styles.review}>{getReviewTitle(getReviewCount(findUniqueObject.requests.filter(object => object.rating > 0 && dayjs(object.reservedAt).diff(dayjs(), 'day') <= -3)))}</Text>
                            </TouchableOpacity>
                            : ""}
                        <Text
                            style={[styles.description, { maxHeight: isExpanded ? 'none' : 170 }]}
                            numberOfLines={isExpanded ? null : 7}
                        >
                            <div className='schedule' dangerouslySetInnerHTML={{ __html: findUniqueObject.description }} />
                        </Text>
                        <TouchableOpacity
                            style={styles.descriptionBtnShowAll}
                            onPress={handleToggle}
                        >
                            <Text style={styles.descriptionBtnShowAllText}>
                                {isExpanded ? 'Свернуть' : 'Показать ещё'}
                            </Text>
                            <View>
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M7.50008 5L12.5001 9.99999L7.50008 15" stroke="black" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </View>
                        </TouchableOpacity>
                        <View style={styles.line} />
                        <Text style={styles.title}>Удобства</Text>
                        {
                            getPeopleCount(findUniqueObject.peopleInfo, findUniqueObject.people)
                        }
                        {
                            getBed(findUniqueObject.bedInfo)
                        }
                        {
                            getSquare(findUniqueObject.square)
                        }
                        {
                            getHeat(findUniqueObject.heat)
                        }
                        {/* <TouchableOpacity onPress={() => navigation.navigate('Comforts', { id })} style={styles.easementButton}>
                            <Text style={styles.easementButtonText}>Показать все удобства</Text>
                        </TouchableOpacity> */}


                        <TouchableOpacity onPress={() => setModalComforts(true)} style={styles.easementButton}>
                            <Text style={styles.easementButtonText}>Показать все удобства</Text>
                        </TouchableOpacity>
                        <Modal
                            visible={modalComforts}
                            // visible={true}
                            animationType="fade"
                            transparent={true}
                        >
                            <ScrollView>
                                <View style={styles.modalComfortsWrapFirst}>
                                    <TouchableOpacity onPress={() => setModalComforts(false)} style={styles.modalComfortsCloseBack}></TouchableOpacity>
                                    <View style={styles.modalComfortsWrap}>
                                        <View style={styles.modalComfortsClose}>
                                            <TouchableOpacity style={styles.modalComfortsCloseBtn} onPress={() => setModalComforts(false)}>
                                                {windowWidth > 768 ? (
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                                        <path d="M8 8L16 16M16 16L24 24M16 16L24 8M16 16L8 24" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                    </svg>
                                                ) : (
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                        <path d="M12.4999 15L7.49994 10L12.4999 5" stroke="black" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
                                                    </svg>
                                                )}
                                            </TouchableOpacity>
                                        </View>
                                        <ComfortsScreen route={route} />
                                    </View>
                                </View>
                            </ScrollView>
                        </Modal>
                        <View style={styles.line} />
                        <Text style={styles.title}>
                            Прайс
                        </Text>
                        {
                            [...findUniqueObject.schedules.filter(schedule => schedule.status == true && schedule.visible == true)].sort((a, b) => a.weightSort - b.weightSort).map((object, index) => (
                                <View key={index} style={[styles.priceContainer, {
                                    marginTop: index === 0 ? 0 : 16,
                                    paddingTop: index === 0 ? 0 : windowWidth > 768 ? 0 : 16,
                                    borderTopWidth: index === 0 ? 0 : windowWidth > 768 ? 0 : 1,
                                }]}>
                                    <View>
                                        <Text style={[styles.week, { maxWidth: dynamicWidth - 150 }]}>{object.name}</Text>
                                        <Text style={styles.day}>с {object.startAt} до {object.endAt}</Text>
                                    </View>
                                    <View style={styles.priceBox}>
                                        {object.discount && object.price > object.discount ? (
                                            <View style={{ flexDirection: 'row' }}>
                                                <Text style={[styles.timeText, { textDecorationLine: 'line-through', color: '#667085' }]}>{object.price} ₽</Text>
                                                <Text style={[styles.timeText]}> {object.discount} ₽</Text>
                                            </View>
                                        ) : (
                                            <Text style={styles.priceText}>{object.discount || object.price} ₽</Text>
                                        )}
                                    </View>
                                </View>
                            ))
                        }
                        {
                            getNote(findUniqueObject.note)
                        }
                        <View style={styles.line} />
                        {
                            getLocation(findUniqueObject.location)
                        }
                        {getRating(findUniqueObject.requests.filter(object => object.rating > 0 && dayjs(object.ratingAt).diff(dayjs(), 'day') <= -3)) > 0 ?
                            <View style={styles.reviewWrap}>
                                <View style={styles.reviewContainer}>
                                    <View style={styles.reviewGroup}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <path d="M12.9019 2.56798C12.7356 2.22088 12.3849 2 12 2C11.6152 2 11.2644 2.22088 11.0982 2.56798L8.45542 8.08482L2.36984 8.8839C1.98727 8.93413 1.66773 9.2 1.54875 9.56705C1.42978 9.93411 1.5326 10.3369 1.81297 10.602L6.26237 14.8093L5.14555 20.8172C5.07514 21.196 5.22857 21.5815 5.53998 21.8083C5.85139 22.0351 6.2654 22.0629 6.60429 21.8797L12 18.9625L17.3958 21.8797C17.7347 22.0629 18.1487 22.0351 18.4601 21.8083C18.7715 21.5815 18.9249 21.196 18.8545 20.8172L17.7377 14.8093L22.1871 10.602C22.4675 10.3369 22.5703 9.93411 22.4513 9.56705C22.3323 9.2 22.0128 8.93413 21.6302 8.8839L15.5446 8.08482L12.9019 2.56798Z" fill="url(#paint0_linear_388_847)" />
                                            <defs>
                                                <linearGradient id="paint0_linear_388_847" x1="16.9256" y1="19.472" x2="7.21987" y2="6.38371" gradientUnits="userSpaceOnUse">
                                                    <stop stopColor="#FF5E3F" />
                                                    <stop offset="0.5" stopColor="#FF8B3F" />
                                                    <stop offset="1" stopColor="#FFB93F" />
                                                </linearGradient>
                                            </defs>
                                        </svg>
                                        <Text style={[{ fontSize: 20, fontWeight: '900', marginLeft: 8 }]}>{getRating(findUniqueObject.requests.filter(object => object.rating > 0 && dayjs(object.ratingAt).diff(dayjs(), 'day') <= -3))}</Text>
                                    </View>
                                    <Text style={[styles.dot, { fontSize: 20, fontWeight: '600', marginHorizontal: 6 }]}>·</Text>
                                    <Text style={[styles.review, { fontSize: 20, fontWeight: '600', textDecorationLine: 'none', margin: 0 }]}>{getReviewTitle(getReviewCount(findUniqueObject.requests.filter(object => object.rating > 0 && dayjs(object.ratingAt).diff(dayjs(), 'day') <= -3)))}</Text>
                                </View>

                                <ScrollView style={styles.reviewScroll} horizontal={isMobile} showsHorizontalScrollIndicator={false}>
                                    <View style={styles.reviewList}>
                                        {
                                            findUniqueObject.requests.filter(object => object.rating > 0 && dayjs(object.ratingAt).diff(dayjs(), 'day') <= -3).slice(0, 6).map((object, index) => (
                                                <TouchableOpacity onPress={() => navigation.navigate('Reviews', { id: findUniqueObject.id })} key={index} style={isMobile ? [styles.reviewItemContainer, { width: 280 }] : styles.reviewItemContainer}>
                                                    <View style={styles.headerReviewItem}>
                                                        <Text style={styles.reviewAuthor}>{object.name}</Text>
                                                        <Text style={styles.reviewDate}>{dayjs(object.reservedAt).format('DD MMMM YYYY')}</Text>
                                                    </View>
                                                    <Text numberOfLines={4} style={styles.reviewText}>{object.review}</Text>
                                                </TouchableOpacity>
                                            ))
                                        }
                                    </View>
                                </ScrollView>
                                {/* <TouchableOpacity onPress={() => navigation.navigate('Reviews', { id: findUniqueObject.id })} style={styles.reviewButton}>
                                    <Text style={styles.reviewButtonText}>Показать все {getReviewCount(findUniqueObject.requests.filter(object => object.rating > 0 && dayjs(object.reservedAt).diff(dayjs(), 'day') <= -3))} отзывов</Text>
                                </TouchableOpacity> */}
                                <TouchableOpacity onPress={() => setModalReviews(true)} style={styles.reviewButton}>
                                    <Text style={styles.reviewButtonText}>Показать все {getReviewTitle(getReviewCount(findUniqueObject.requests.filter(object => object.rating > 0 && dayjs(object.reservedAt).diff(dayjs(), 'day') <= -3)))}</Text>
                                </TouchableOpacity>
                            </View>

                            : ""}
                        <Modal
                            visible={modalReviews}
                            // visible={true}
                            animationType="fade"
                            transparent={true}
                        >
                            <ScrollView>
                                <View style={styles.modalComfortsWrapFirst}>
                                    <TouchableOpacity onPress={() => setModalReviews(false)} style={styles.modalComfortsCloseBack}></TouchableOpacity>
                                    <View style={styles.modalComfortsWrap}>
                                        <View style={styles.modalComfortsClose}>
                                            <TouchableOpacity style={styles.modalComfortsCloseBtn} onPress={() => setModalReviews(false)}>
                                                {windowWidth > 768 ? (
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                                        <path d="M8 8L16 16M16 16L24 24M16 16L24 8M16 16L8 24" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                    </svg>
                                                ) : (
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                        <path d="M12.4999 15L7.49994 10L12.4999 5" stroke="black" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
                                                    </svg>
                                                )}
                                            </TouchableOpacity>
                                        </View>
                                        <ReviewsScreen route={route} />
                                    </View>
                                </View>
                            </ScrollView>
                        </Modal>
                        <Text style={[styles.title, { marginTop: 16 }]}>
                            Бронирование и отмена
                        </Text>
                        <View style={{ marginBottom: windowWidth > 435 ? 28 : 8 }}>
                            <div class="booking_wrap" dangerouslySetInnerHTML={{ __html: findUniqueObject.booking }} />
                        </View>
                        <View style={styles.line} />
                        <Text style={[styles.title, { marginTop: windowWidth > 435 ? 28 : 8 }]}>
                            Правила пребывания
                        </Text>
                        <Text
                            style={[styles.description, { marginTop: 0, maxHeight: isExpandedRules ? 'none' : 'none' }]}
                            numberOfLines={isExpandedRules ? null : 10}
                        >
                            <div class="booking_wrap" dangerouslySetInnerHTML={{ __html: findUniqueObject.rules }} />
                        </Text>
                        <TouchableOpacity
                            style={styles.descriptionBtnShowAll}
                            onPress={handleToggleRules}
                        >
                            <Text style={styles.descriptionBtnShowAllText}>
                                {isExpandedRules ? 'Свернуть' : 'Показать ещё'}
                            </Text>
                            <View>
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M7.50008 5L12.5001 9.99999L7.50008 15" stroke="black" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </View>
                        </TouchableOpacity>
                    </View>
                </Window>
            </ScrollView>
            <Window>
                {findUniqueObject.publish ?
                    <View style={styles.footer}>
                        <TouchableOpacity onPress={() => navigation.navigate('Reserve', { id, date })} style={styles.bookedButton}>
                            <Text style={styles.bookedButtonText}>Выбрать дату</Text>
                        </TouchableOpacity>
                    </View> : ''}
            </Window>
            <FsLightbox
                toggler={toggler}
                sources={imagesLightbox}
                sourceIndex={carouselIndex}
            />
        </>
    )
}

const windowWidth = Dimensions.get('window').width;
const windowHeight = Dimensions.get('window').height;

const styles = StyleSheet.create({
    container: {
        flex: 1,
        paddingHorizontal: windowWidth > 768 ? 16 : 0,
    },
    objectImage: {
        overflow: 'hidden',
    },
    head: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        position: 'absolute',
        left: 0,
        top: 0,
        right: 0
    },
    back: {
        height: 40,
        width: 40,
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 20,
        borderColor: '#D1D5DB',
        borderWidth: 1,
        backgroundColor: '#fff',
        margin: windowWidth > 768 ? 0 : 16,
    },
    favorite: {
        height: 40,
        width: 40,
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 20,
        borderColor: '#D1D5DB',
        borderWidth: 1,
        backgroundColor: '#fff',
        margin: windowWidth > 768 ? 0 : 16,
        marginLeft: windowWidth > 768 ? 0 : 0,
    },
    copyLink: {
        height: 40,
        width: 40,
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 20,
        borderColor: '#D1D5DB',
        borderWidth: 1,
        backgroundColor: '#FFF',
        margin: windowWidth > 768 ? 0 : 16,
    },
    tagsContainer: {
        flexDirection: 'row',
        justifyContent: 'end',
        alignItems: 'center',
        marginBottom: windowWidth > 768 ? 20 : 48,
        marginRight: windowWidth > 768 ? 20 : 16,
        marginTop: 16,
        marginLeft: 16,
        position: 'absolute',
        left: 0,
        right: 0,
        bottom: 0
    },
    tagHot: {
        height: 28,
        width: 135,
        borderRadius: 6,
        backgroundColor: '#E6B762',
        justifyContent: 'center',
        alignItems: 'center'
    },
    hotText: {
        color: '#FCFCFD',
        fontSize: 16,
        fontWeight: '400'
    },
    countContainer: {
        height: 28,
        paddingHorizontal: 10,
        borderRadius: 6,
        backgroundColor: 'rgba(17, 25, 40, 0.64)',
        backdropFilter: 'blur(8px)',
        justifyContent: 'center',
        alignItems: 'center'
    },
    countText: {
        color: '#fff',
        fontWeight: '500',
    },
    title: {
        marginTop: 8,
        marginBottom: 24,
        fontSize: 20,
        fontWeight: 600,
        lineHeight: '150%',
    },
    titleObject: {
        fontSize: 24,
        color: '#101828',
        fontWeight: '600',
        marginTop: 16,
        marginBottom: 12,
    },
    reviewContainer: {
        flexDirection: 'row',
        alignItems: 'center'
    },
    reviewGroup: {
        flexDirection: 'row',
        alignItems: 'center'
    },
    dot: {
        marginHorizontal: 4,
        color: '#101828',
        fontWeight: '900'
    },
    review: {
        color: '#101828',
        fontWeight: '500',
        textDecorationLine: 'underline',
        fontSize: 14,
        marginLeft: 8,
    },
    rate: {
        marginLeft: 4,
        color: '#101828',
        fontSize: 14,
        fontWeight: 500
    },
    description: {
        color: '#101828',
        marginTop: 24,
        maxWidth: 744,
        fontSize: 16,
        overflow: 'hidden',
    },
    line: {
        marginVertical: 16,
        height: 1,
        backgroundColor: '#EAECF0'
    },
    easementButton: {
        borderWidth: 1,
        borderColor: '#111928',
        borderRadius: 8,
        marginTop: 12,
        marginBottom: 8,
        width: windowWidth > 435 ? 244 : '100%',
    },
    easementButtonText: {
        color: '#111928',
        fontSize: 16,
        lineHeight: '150%',
        paddingHorizontal: 24,
        paddingVertical: 12,
        textAlign: 'center',
        fontWeight: 500,
    },
    infoContainer: {
        flexDirection: 'row',
        alignItems: 'flex-start',
        marginBottom: 18,
        maxWidth: 744,
    },
    infoText: {
        color: '#101828',
        marginLeft: 16,
        fontSize: 16,
    },
    tabsContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 16
    },
    tabContainer: {
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
        height: 40,
        borderWidth: 1,
        borderColor: '#D0D5DD',
        borderRadius: 4
    },
    tabText: {
        color: '#101828',
        textAlign: 'center',
        fontSize: 12
    },
    selectTabContainer: {
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
        height: 40,
        borderRadius: 4,
        backgroundColor: '#101828'
    },
    selectTabText: {
        color: '#FCFCFD',
        textAlign: 'center',
        fontSize: 12
    },
    priceContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        maxWidth: 744,
        borderTopWidth: windowWidth > 768 ? 1 : 0,
        borderTopColor: '#E5E7EB',
    },
    priceBox: {
        fontSize: 16,
        fontWeight: 500,
        lineHeight: '150%',
    },
    week: {
        color: '#111928',
        fontSize: 16,
        lineHeight: '150%',
        fontWeight: 500,
    },
    day: {
        color: '#111928',
        fontSize: 16,
        fontWeight: 400,
        lineHeight: '150%',
        marginTop: 8,
    },
    reviewScroll: {
        paddingVertical: 16,
        marginHorizontal: -16,
        paddingLeft: 16,
    },
    reviewList: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: 16,
        maxHeight: 510,
    },
    reviewItemContainer: {
        width: 300,
        padding: 16,
        borderRadius: 20,
        backgroundColor: '#fff',
        boxShadow: '0px 4px 6px -1px rgba(0, 0, 0, 0.10), 0px 2px 4px -2px rgba(0, 0, 0, 0.05)'
    },
    headerReviewItem: {
        flexDirection: 'row',
        marginBottom: 8
    },
    reviewAuthor: {
        color: '#111928',
        fontWeight: '600',
        marginRight: 6
    },
    reviewDate: {
        color: '#6B7280',

    },
    reviewText: {
        color: '#111928',
        fontSize: 16,
        lineHeight: '150%'
    },
    reviewButton: {
        borderWidth: 1,
        borderColor: '#111928',
        borderRadius: 8,
        justifyContent: 'center',
        alignItems: 'center',
        width: windowWidth > 435 ? 306 : '100%',
    },
    reviewButtonText: {
        fontSize: 16,
        fontWeight: '500',
        lineHeight: '150%',
        color: '#111928',
        paddingVertical: 12
    },
    footer: {
        borderTopWidth: 1,
        borderColor: '#D0D5DD',
        padding: 16
    },
    actions: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    price: {
        fontSize: 20,
        fontWeight: '500',
        color: '#101828'
    },
    dayType: {
        marginLeft: 8,
    },
    date: {
        fontWeight: '500',
    },
    bookedButton: {
        justifyContent: 'center',
        alignItems: 'center',
        height: 48,
        borderRadius: 8,
        backgroundColor: '#E6B762'
    },
    bookedButtonText: {
        color: '#101828',
        fontWeight: '500'
    },
    scroll: {
        height: 30,
        width: 30,
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 18,
        backgroundColor: '#EAECF0',
        position: 'absolute',
    },
    objectInfoWrap: {
        backgroundColor: '#fff',
        position: 'relative',
        bottom: windowWidth > 768 ? 0 : 20,
        paddingHorizontal: windowWidth > 768 ? 0 : 16,
        borderTopStartRadius: 20,
        borderTopEndRadius: 20,
    },
    objectImagesPaginationWrap: {
        flexDirection: 'row',
        position: 'absolute',
        columnGap: 3,
        width: '100%',
        justifyContent: 'center',
        bottom: 36

    },
    objectImagesPagination: {
        width: 6,
        height: 6,
        backgroundColor: '#D1D5DB',
        borderRadius: 6,
    },
    objectImagesPaginationActive: {
        backgroundColor: '#fff',
    },
    desktopImageWrap: {
        flexDirection: 'row',
        width: '100%',
        borderRadius: 16,
        overflow: 'hidden',
        gap: 8,
    },
    firstObjectImage: {
        width: '50%',
        aspectRatio: 1 / 1,
    },
    otherObjectImage: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        width: '50%',
        gap: 8,
    },
    objectBtnWrap: {
        justifyContent: 'space-between',
        flexDirection: 'row',
        marginBottom: 36,
        marginTop: 36,
    },
    priceText: {
        fontSize: 16,
        fontWeight: 500,
        lineHeight: '150%'
    },
    reviewWrap: {
        paddingHorizontal: 20,
        paddingVertical: 24,
        backgroundColor: '#F9FAFB',
        borderRadius: windowWidth > 1024 ? 16 : 0,
        borderColor: windowWidth > 1024 ? '' : '#E5E7EB',
        borderWidth: windowWidth > 1024 ? 0 : 1,
        marginTop: 24,
        marginHorizontal: windowWidth > 1024 ? 0 : -16
    },
    infoContainerIcon: {
        width: 24
    },
    descriptionBtnShowAll: {
        flexDirection: 'row',
        gap: 4,
        alignItems: 'center',
        marginTop: 12
    },
    descriptionBtnShowAllText: {
        color: '#101828',
        fontSize: 16,
        lineHeight: '150%',
        textDecorationLine: 'underline',
        fontWeight: 500
    },
    modalComfortsWrapFirst: {
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        position: 'relative',
    },
    modalComfortsWrap: {
        borderRadius: windowWidth > 768 ? 16 : 0,
        maxWidth: 800,
        width: '100%',
        backgroundColor: '#fff',
        overflow: 'hidden',
        marginVertical: windowWidth > 768 ? 80 : 0,
        zIndex: 20,
        position: 'relative',
        minHeight: windowWidth > 768 ? '90vh' : '100vh',
        paddingTop: 48
    },
    modalComfortsClose: {
        backgroundColor: '#fff',
        paddingTop: windowWidth > 768 ? 24 : 22,
        paddingBottom: windowWidth > 768 ? 16 : 22,
        paddingHorizontal: windowWidth > 768 ? 24 : 22,
        borderBottomWidth: windowWidth > 768 ? 1 : 0,
        borderColor: '#E6E6E6',
    },
    modalComfortsCloseBtn: {
        width: 'fit-content'
    },
    modalComfortsCloseBack: {
        width: '100%',
        height: '100%',
        position: 'absolute',
        zIndex: 10
    }
})

export default ObjectScreen
